<a
  *ngIf="icon"
  type="button"
  mdbBtn
  tabindex="0"
  [floating]="floating"
  [outline]="outline"
  [size]="size"
  [color]="color"
  [classList]="'d-flex justify-content-center align-items-center ' + class"
  [mdbTooltip]="tooltip!"
  (click)="handleClick($event)"
  (keyup.enter)="handleClick()"
>
  <jhi-bary-icon *ngIf="outline" [icon]="icon" [faDirective]="FAS" [class]="'text-' + color"></jhi-bary-icon>
  <jhi-bary-icon *ngIf="!outline" [icon]="icon" [faDirective]="FAS"></jhi-bary-icon>
</a>
